


const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case "INITIALISE": {
          const { isAuthenticated, user, isInitialised } = action.payload;
    
          return {
            ...state,
            isAuthenticated,
            isInitialised,
            user,
          };
        }
        case "LOGIN": {
          const { user } = action.payload;
          return {
            ...state,
            isAuthenticated: true,
            isInitialised: false,
            user,
          };
        }
        
        case "LOGOUT": {
          return {
            isAuthenticated: false,
            user: null,
            isInitialised: false,

          };
        }
    
        default: {
          return { ...state };
        }
      }
};
